module.exports = __webpack_public_path__ + "media/assets/images/icons/flags/th-9e7c7a3f1af6d93b83f9096c02a28776.svg";